import * as React from "react";
import { forwardRef } from "react";
const SvgTask = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 26, height: 26, viewBox: "0 0 26 26", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4 4.3v17.477h17.477V10.262l-1.457 1.456v8.6H5.456V5.756h14.428L21.34 4.3Zm16.953 2.389L12.738 14.9l-3.117-3.113-1.047 1.047 3.641 3.641.523.5.523-.5L22 7.736Z", className: "se0c13a2fc84fb8dcd894dec18da7fdac__d" }));
const ForwardRef = forwardRef(SvgTask);
export { ForwardRef as ReactComponent };
